import { defineMessages } from 'react-intl';

export default defineMessages({
  salutation: {
    id: 'LOGIN_BLACKLISTED_SALUTATION',
    defaultMessage: 'Liebes Mitglied,',
  },
  paragraph1: {
    id: 'LOGIN_BLACKLISTED_PARAGRAPH_1',
    defaultMessage:
      'Ihr XING Profil wurde aus Sicherheitsgründen oder aufgrund eines vorliegenden Verstoßes gegen unsere AGB gesperrt.',
  },
  paragraph2: {
    id: 'LOGIN_BLACKLISTED_PARAGRAPH_2',
    defaultMessage:
      'Gerne prüfen wir die Möglichkeit, ihr Profil wieder freizuschalten. Kontaktieren Sie uns hierzu - idealerweise über die in Ihrem XING Profil hinterlegte Benachrichtigungsadresse - per Mail an: .',
  },
  paragraph2linkTarget: {
    id: 'LOGIN_BLACKLISTED_P2_MAILTO_TARGET',
    defaultMessage: 'mailto:de-quality@xing.com',
  },
  paragraph2linkText: {
    id: 'LOGIN_BLACKLISTED_P2_MAILTO_TEXT',
    defaultMessage: 'de-quality@xing.com',
  },
  paragraph3: {
    id: 'LOGIN_BLACKLISTED_PARAGRAPH_3',
    defaultMessage:
      'Mögliche Gründe, die zu einer Sperrung führen können, finden sie auch in unserem {helpCenterLink}. ',
  },
  paragraph3linkTarget: {
    id: 'LOGIN_BLACKLISTED_P3_HELPSECTION_LINK_TARGET',
    defaultMessage: 'https://faq.xing.com/de/sicherheit/gesperrtes-xing-profil',
  },
  paragraph3linkText: {
    id: 'LOGIN_BLACKLISTED_P3_HELPSECTION_LINK_TEXT',
    defaultMessage: 'Hilfebereich',
  },
});
